export default __webpack_public_path__ + "static/media/fb_chat_2011.eacdfd95.mp3";